import InstagramFeed from "@/components/InstagramFeed";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SocialProof from "@/components/SocialProof";
import ScrollShowcase from "@/components/ScrollShowcase";
import Marquee from "@/components/Marquee";
import Maison from "@/components/Maison";
import Products from "@/components/Products";
import Rental from "@/components/Rental";
import Partner from "@/components/Partner";
import Reviews from "@/components/Reviews";
import HelpChoice from "@/components/HelpChoice";
import Contact from "@/components/Contact";
import Experience from "@/components/Experience";
import Newsletter from "@/components/Newsletter";
import FooterActions from "@/components/FooterActions";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="relative bg-cream grain" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <Marquee />
        <ScrollShowcase />
        <Maison />
        <Products />
        <Rental />
        <Partner />
        <Reviews />
        <HelpChoice />
        <Contact />
        <Experience />
        <Newsletter />
        <FooterActions />
      </main>
      <InstagramFeed />
      <Footer />
    </div>
  );
}

export default App;


